<template>

    <div class="mb-3" :class="{'form-floating': floating}" style="max-width: 600px;">

        <label v-if="label && floating === false" class="form-label" :for="id">
            {{ translatedLabel }}
            <span v-if="help">
                <i class="bi bi-question-circle" :title="help"></i>
            </span>
        </label>

        <treeselect 
            :id="id" 
            ref="input" 
            v-bind="$attrs" 
            v-model="selected" 
            :options="treeOptions" 
            />

        <label v-if="label && floating" class="form-label" :for="id">
            {{ translatedLabel }}
        </label>

        <div v-if="error" class="invalid-feedback d-block">{{ error }}</div>

    </div>

</template>

<style>
    .vue-treeselect__control {
        height: 44px;
    }
    .vue-treeselect__multi-value-item {
        padding: 6px 0;
    }
    .vue-treeselect--searchable.vue-treeselect--multi.vue-treeselect--has-value .vue-treeselect__input-container {
        padding-top: 9px;
    }
    .vue-treeselect__placeholder, .vue-treeselect__single-value {
        line-height: 42px;
    }
</style>

<script>

    import Treeselect from '@riophae/vue-treeselect';
    import { ASYNC_SEARCH } from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';

    export default {
        inheritAttrs: false,
        props: {
            id: {
                type: String,
                default() {
                    return `multi-select-input-${this._uid}`
                },
            },
            value: [String, Number, Array],
            floating: {
                default: false,
            },
            label: String,
            error: String,
            help: String,
            options: Array,
        },
        components: {
            Treeselect,
        },
        data() {
            return {
                selected: this.value,
                treeOptions: this.options,
            }
        },
        watch: {
            selected(selected) {
                this.$emit('input', selected)
            },
            value() {
                this.selected = this.value;
            }
        },
        computed: {
            translatedLabel() {
                return this.langHas('validation.attributes.' + this.label)
                        ? this.__('validation.attributes.' + this.label)
                        : this.label;
            }
        },
        methods: {
            focus() {
                this.$refs.input.focus()
            },
            select() {
                this.$refs.input.select()
            },
        },
    }
</script>
